// Dev build (`npm run dev`) — NestJS API on Railway.
// Replace <your-railway-domain> with your Railway-generated domain.
export const environment = {
  production: true,
  baseUrl: 'https://api-test.aquasteamservices.com/',
  apiUrl: 'https://api-test.aquasteamservices.com/api/',
  google: {
    clientId:
      '675234261756-849o992vrv2dnt0e4d367lr2uri1bkj6.apps.googleusercontent.com',
    redirectUri: 'https://test.aquasteamservices.com/google/callback',
  },
};
